import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

import { isHiddenByParentElement } from "helpers/isHiddenByParentElement";

import EditPolygonForm from "scenes/MapPage/components/EditPolygonForm/EditPolygonForm";

import styles from "./map-layers.module.scss";

interface EditPolygonPortalInterface {
  activePolygonsListItem: any;
  onClose: () => void;
}
const EditPolygonPortal = ({
  activePolygonsListItem,
  onClose
}: EditPolygonPortalInterface) => {
  const formRef = useRef<HTMLDivElement | null>(null);

  const [position, setPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);

  useEffect(() => {
    if (activePolygonsListItem) {
      const targetElement = document.getElementById(activePolygonsListItem.id);
      const containerElement = document.getElementById("mapLayoutScrollWrapperId");
      const expandAreasBlock = document.getElementById("areas-expand");
      const expandedAreasBlockPart = document.getElementById("accordion-areas-expand");
  
      if (targetElement) {
        const checkVisibility = () => {
          const elRect = targetElement.getBoundingClientRect();
          const containerRect = containerElement.getBoundingClientRect();
          return elRect.top >= containerRect.top && elRect.bottom <= containerRect.bottom;
        };
  
        let scrollTimeout;
  
        const handleScroll = () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            if (checkVisibility()) {
              updatePosition(targetElement);
              containerElement.removeEventListener("scroll", handleScroll);
            }
          }, 100);
        };
  
        const startScrollToItem = () => {
          containerElement.addEventListener("scroll", handleScroll);
          containerElement.scrollTo({
            top: targetElement.offsetTop - containerElement.offsetTop,
            behavior: "smooth",
          });
        };
  
        if (!isHiddenByParentElement(expandedAreasBlockPart)) {
          startScrollToItem();
        } else {
          expandAreasBlock.click();
  
          const waitForFullExpand = (prevHeight = 0, attempts = 0) => {
            requestAnimationFrame(() => {
              const currentHeight = expandedAreasBlockPart.offsetHeight;
  
              if (currentHeight === prevHeight && attempts > 5) {
                startScrollToItem();
              } else {
                waitForFullExpand(currentHeight, attempts + 1);
              }
            });
          };
  
          waitForFullExpand();
        }
  
        if (checkVisibility()) {
          updatePosition(targetElement);
        }
      }
    }
  }, [activePolygonsListItem]);

  const updatePosition = (targetElement) => {
    const elRect = targetElement.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const formWidth = 345;
    const formHeight = 418;

    let top = elRect.bottom + window.scrollY + 5;
    let left = elRect.right + window.scrollX - formWidth + 16;

    if (top + formHeight > windowHeight + window.scrollY) {
      top = elRect.top + window.scrollY - formHeight - 5;
    }

    if (left < 0) {
      left = 5;
    }

    setPosition((prev) =>
      prev?.top === top && prev?.left === left ? prev : { top, left }
    );
  };

  if (!activePolygonsListItem?.id || !position) return null;

  return createPortal(
    <div
      ref={formRef}
      style={{
        top: position.top,
        left: position.left
      }}
      className={styles["edit-polygon-portal-container"]}
    >
      <EditPolygonForm areaData={activePolygonsListItem} onClose={onClose} />
    </div>,
    document.body
  );
};
export default EditPolygonPortal;
